import React from "react"
import styled from "styled-components"

import { Element, ElementProps, elementCss } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { PrismicImageType } from "types/__generated__/gatsby-graphql"
import { AspectRatioProps } from "../customStyleProps"
interface OwnProps {
  aspectRatio: AspectRatioProps
  imageData: Maybe<PrismicImageType>
}

export type ImageProps = ElementProps & OwnProps

const Image = styled(
  ({
    aspectRatio,
    imageData: { alt, url },
    height = "auto",
    width,
    ...props
  }): React.ReactElement | null => {
    if (!alt || !url) return null

    return (
      <Element
        alt={alt}
        as="img"
        aspectRatio={aspectRatio}
        height={height}
        maxWidth="100%"
        width={width}
        src={url}
        {...props}
      />
    )
  }
)<ImageProps>`
  ${elementCss}
`

Image.defaultProps = {
  fontSize: ["12", "text.body"],
  width: "100%",
}

export default Image
